import React, { useEffect, useState } from "react";
import axios from "axios";

import ApprovalTable from "./ApprovalTable";
import { API_BASE_URL } from "../../../config/api";

const ApprovalPage = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    axios
      .get(`${API_BASE_URL}/api/requests/approved`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        console.log("Full API response:", res.data);

        const normalized = (res.data.items || []).map((req) => ({
          requestId: req.requestId,
          createdAt: req.createdAt,
          department: req.department,
          positionType: req.positionType,
          assigned: req.assigned,
          positionTitle: req.positionTitle,
          status: req.status,
        }));

        console.log("Normalized requests:", normalized);
        setRequests(normalized);
      })
      .catch((err) => {
        console.error("Error fetching requests:", err);
        setRequests([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <div className="w-full h-screen p-2 bg-gray-50">
      <h2 className="mb-4 text-2xl font-MTNfont">Approved Requests</h2>
      {loading ? (
        <p className="text-gray-500">Loading Approved Requests...</p>
      ) : (
        <ApprovalTable requests={requests} />
      )}
    </div>
  );
};

export default ApprovalPage;
